import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = { url: String }

    async connect() {
        const { default: Sortable } = await import("sortablejs")
        this.sortable = Sortable.create(this.element, {
            animation: 200,
            ghostClass: "opacity-30",
            onEnd: () => this.saveOrder()
        })
    }

    disconnect() {
        this.sortable?.destroy()
    }

    async saveOrder() {
        const imageIds = Array.from(this.element.children).map(el => el.dataset.blobId)
        const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

        await fetch(this.urlValue, {
            method: "PATCH",
            headers: {
                "X-CSRF-Token": csrfToken,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({ image_ids: imageIds })
        })
    }
}
